import { Component, EventEmitter, OnDestroy, OnInit, Output, ChangeDetectorRef, ChangeDetectionStrategy } from '@angular/core';
import { Subject, Subscription, takeUntil } from 'rxjs';
import * as _ from 'lodash-es';
import { GtwSnackbarService } from '../../../../shared/_services/gtw-snackbar.service';
import { RepointTabService } from './repoint-tab.service';
import { GlobalService } from '../../../../global/services/global.service';
import { WorkspaceService } from '../../../../workspace/workspace.service';
import { AppService } from '../../../../app.service';
import {
  buildHeaderDataShell,
  generalConfigFromGlobal,
  normalizeFilterParams,
  rowPayloadFromActiveScreen
} from '../../../../shared/workspace-element-context';

@Component({
    selector: 'gtw-trial-balance-repoint-tab',
    templateUrl: './repoint-tab.component.html',
    styleUrls: ['./repoint-tab.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class RepointTabComponent implements OnInit, OnDestroy {
  @Output('request-grid-update') requestGridUpdate = new EventEmitter<any>();

  private unsubscribe$ = new Subject<void>();
  private readonly subs = new Subscription();
  private isInitialized = false;
  private isLoading = false;

  modalTitle = 'Trial Balance Repointing';
  minimise = false;
  crudLoading = false;
  loading = false;
  loadLookUpData = false;
  rowData: any = {};
  curr = '';
  curr5471 = '';
  curr8858: string | null = null;
  ACCT_TYPE = '';
  CHART_DISPLAY = '';
  LOCAL_ACCT_DISPLAY = '';
  SYSTEM_ACC_DISPLAY = '';
  cyAmount = 0;
  elimAmount = 0;
  repointingAmount = 0;
  remainingCyAmount = 0;
  adjAmount5471 = 0;
  adjAmount8858 = 0;
  pyAmount = 0;
  Repoint: any = {
    SYSC_ACCT: '',
    SYS_ACCT_KEY: '',
    TRANS_HEADER_KEY: '',
    TRANS_DETAILS_KEY: '',
    IRS_Form: '',
    IRS_SCHEDULE: '',
    CHECK_COL: '',
    IRS_LINE: '',
    IRS_LINE_DESC: '',
    LOOK_UP_BTN: '',
    AMMOUNT: '',
    ADJUSTMENT_DESC: ''
  };
  OLD_DESC = '';
  repointList: any[] = [];
  tempDeletedRepointList: any[] = [];
  loadSystemAndLocalAccountData: any[] = [];
  sys_acc_lookup_data: any[] = [];
  sys_acc_dropdown_data: any[] = [];
  tpSearchResults: any[] = [];
  activeTPSearchIndex = -1;
  loadingTpSearch = false;
  repoint_data: any[] = [];
  loadLookupForm: string[] = [];
  sendobj: any[] = [];
  showRepointingError = false;
  showRepointingDescError = false;
  acctzeroflag = false;
  irsFormFlag = false;
  irsScheduleFlag = false;
  addRepointClicked = false;
  lookUpMapping = false;
  sysacctFlag = false;
  is_data_saved = false;
  group_key = 0;
  orderByField = '';
  reverseSort: boolean | string = false;
  sort_key: { [key: string]: number } = { '1': 0, '2': 0, '3': 0, '4': 0, '5': 0 };
  GENERAL_CONFIG: any = {};
  baseURLs: any = {};
  globalService: any = {};
  filterParams: any = {};

  get sortedSystemAndLocalAccountData(): any[] {
    if (!this.loadSystemAndLocalAccountData || this.loadSystemAndLocalAccountData.length === 0) {
      return [];
    }
    if (!this.orderByField || this.reverseSort === '') {
      return this.loadSystemAndLocalAccountData;
    }
    const sortedData = [...this.loadSystemAndLocalAccountData];
    sortedData.sort((a: any, b: any) => {
      const valA = a[this.orderByField] || '';
      const valB = b[this.orderByField] || '';
      let comparison = 0;
      if (valA < valB) {
        comparison = -1;
      } else if (valA > valB) {
        comparison = 1;
      }
      return this.reverseSort === true ? -comparison : comparison;
    });
    return sortedData;
  }

  constructor(
    private gtwGlobal: GlobalService,
    private gtwWorkspace: WorkspaceService,
    private gtwApp: AppService,
    private service: RepointTabService,
    private gtwSnackbarService: GtwSnackbarService,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.applyWorkspaceContext();
    this.subs.add(this.gtwWorkspace.setTabActive.subscribe(() => { this.applyWorkspaceContext(); this.tryInit(); }));
    this.subs.add(this.gtwGlobal.globalParamsChanged$.subscribe(() => { this.applyWorkspaceContext(); this.tryInit(); }));
    this.tryInit();
  }

  private applyWorkspaceContext(): void {
    const activeScreen = this.gtwWorkspace.workspaceFactory?.activeScreen || {};
    const header = buildHeaderDataShell(this.gtwGlobal, this.gtwApp);
    this.baseURLs = generalConfigFromGlobal(this.gtwGlobal);
    this.globalService = header;
    this.GENERAL_CONFIG = { ...this.baseURLs, ...(header.generalConfigData || {}) };
    this.filterParams = normalizeFilterParams(activeScreen);
    this.rowData = rowPayloadFromActiveScreen(activeScreen);
    this.cdr.detectChanges();
  }

  private tryInit() {
    if (this.isInitialized || this.isLoading) {
      return;
    }
    const baseUrl = this.baseURLs?.api || this.GENERAL_CONFIG?.base_url || '';
    if (this.rowData && Object.keys(this.rowData).length > 0 && baseUrl) {
      if (!this.baseURLs?.api && baseUrl) {
        this.baseURLs = { ...this.baseURLs, api: baseUrl };
      }
      this.isInitialized = true;
      this.init();
    }
  }

  init() {
    this.crudLoading = false;
    this.setupDisplayData();
    this.loadAllData();
  }

  private setupDisplayData() {
    this.curr = this.rowData.FC || '';
    this.curr5471 = this.rowData.HO_CURR || '';
    this.curr8858 = this.rowData.CURR_8858 !== undefined ? this.rowData.CURR_8858 : null;
    this.ACCT_TYPE = this.rowData.ACCT_TYPE || '';
    this.CHART_DISPLAY = this.rowData.LOCAL_CHART_CODE || '';
    this.LOCAL_ACCT_DISPLAY = this.rowData.LOCAL_ACCT || '';
    this.SYSTEM_ACC_DISPLAY = this.rowData.SYSTEM_ACCT || '';
    this.cyAmount = this.rowData.BOOK_AMT || 0;
    this.elimAmount = this.rowData.ELIM_AMT_FEED_CURR || 0;
    this.adjAmount5471 = this.rowData.ADJUSTED_5471_TAX_AMT || 0;
    this.adjAmount8858 = this.rowData.ADJUSTED_8858_TAX_AMT || 0;
    this.pyAmount = this.rowData.BOY_AMT || 0;
    this.remainingCyAmount = this.cyAmount - this.repointingAmount;
    this.cdr.detectChanges();
  }

  private loadAllData() {
    this.isLoading = true;
    this.getSystemAcctLookup();
    this.getSystmAcctDropDown();
    this.fetchSystemAcctData();
    this.getDefaultSystemAcctValues();
  }

  private getSystmAcctDropDown() {
    const globalParams = this.globalService?.globalParams || this.globalService || {};
    this.service.getSystmAcctDropDown(
      this.baseURLs.api,
      this.rowData.SCREEN_KEY || this.filterParams?.screen_key || globalParams?.screen_key || 175,
      this.rowData.SYSTEM_ACCT_TYPE,
      this.rowData.SOURCE_SYSTEM,
      this.rowData.SYSTEM_ACCT_KEY,
      globalParams,
      this.filterParams || {}
    ).pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {
      this.sys_acc_dropdown_data = data?.jsonObject || [];
      this.cdr.detectChanges();
    });
  }

  searchTradingPartners(event: any, index: number): void {
    const val = (event.target as HTMLInputElement).value;
    if (this.repointList[index]) {
      this.repointList[index].tpSearchText = val;
      this.repointList[index].TP_ENTITY = val;
    }
    if (!val || val.length < 3) {
      this.tpSearchResults = [];
      this.activeTPSearchIndex = -1;
      this.cdr.detectChanges();
      return;
    }
    this.activeTPSearchIndex = index;
    this.loadingTpSearch = true;
    const globalParams = this.globalService?.globalParams || this.globalService || {};
    const taxYear = this.filterParams?.tax_year || globalParams?.tax_year || this.rowData?.TAX_YEAR;
    const scenario = this.filterParams?.scenario || globalParams?.scenario || this.rowData?.SCENARIO;
    this.service.getTradingPartners(
      this.baseURLs.api,
      taxYear,
      scenario,
      val,
      this.rowData.SOURCE_SYSTEM,
      globalParams
    ).pipe(takeUntil(this.unsubscribe$)).subscribe(
      (data: any) => {
        this.tpSearchResults = data?.jsonObject || [];
        this.loadingTpSearch = false;
        this.cdr.detectChanges();
      },
      () => {
        this.tpSearchResults = [];
        this.loadingTpSearch = false;
        this.cdr.detectChanges();
      }
    );
  }

  selectTradingPartner(tp: any, index: number): void {
    if (!this.repointList[index] || !tp) return;
    this.repointList[index].tpObject = tp;
    this.repointList[index].TP_ENTITY = tp.TP_ENTITY;
    this.repointList[index].TP_KEY = tp.TP_KEY;
    this.repointList[index].TP_REP_PD = tp.TP_REP_PD;
    this.repointList[index].tpSearchText = tp.TP_ENTITY;
    this.tpSearchResults = [];
    this.activeTPSearchIndex = -1;
    this.cdr.detectChanges();
  }

  sortBy(key: string, value: number) {
    Object.keys(this.sort_key).forEach(k => {
      if (k !== key) {
        this.sort_key[k] = 0;
      }
    });
    switch (value) {
      case 0:
        this.sort_key[key] = 1;
        this.reverseSort = false;
        break;
      case 1:
        this.sort_key[key] = 2;
        this.reverseSort = true;
        break;
      case 2:
        this.sort_key[key] = 0;
        this.reverseSort = '';
        this.orderByField = '';
        break;
    }
    this.cdr.detectChanges();
  }

  adjDescChanged() {
    this.showRepointingDescError = this.repointList.length > 0 && (!this.Repoint.ADJUSTMENT_DESC || this.Repoint.ADJUSTMENT_DESC === '');
    this.cdr.detectChanges();
    return this.showRepointingDescError;
  }

  addRepoint() {
    this.addRepointClicked = true;
    let tempTransHeader_key: string | number = 0;
    for (let i = 0; i < this.repointList.length; i++) {
      if (this.repointList[i].TRANS_HEADER_KEY && Number(this.repointList[i].TRANS_HEADER_KEY) > 0) {
        tempTransHeader_key = this.repointList[i].TRANS_HEADER_KEY;
        break;
      }
    }
    this.group_key = this.group_key + 1;

    const lookupData = _.cloneDeep(this.sys_acc_lookup_data);
    const firstMapRow = (this.loadSystemAndLocalAccountData && this.loadSystemAndLocalAccountData.length > 0)
      ? this.loadSystemAndLocalAccountData[0]
      : null;
    const lineDesc = firstMapRow ? `${firstMapRow.LINE} - ${firstMapRow.LINE_DESC}` : '';

    // Match AngularJS behavior: add one repoint row per click.
    this.repointList.push({
      SYSC_ACCT: this.Repoint.SYSC_ACCT || '',
      SYS_ACCT_KEY: this.Repoint.SYS_ACCT_KEY || '',
      IRS_Form: firstMapRow ? firstMapRow.FORM : (this.Repoint.IRS_Form || ''),
      IRS_SCHEDULE: firstMapRow ? firstMapRow.SCHEDULE : (this.Repoint.IRS_SCHEDULE || ''),
      IRS_LINE: firstMapRow ? firstMapRow.LINE : (this.Repoint.IRS_LINE || ''),
      IRS_LINE_DESC: firstMapRow ? lineDesc : (this.Repoint.IRS_LINE_DESC || ''),
      CHECK_COL: firstMapRow ? firstMapRow.COL : (this.Repoint.CHECK_COL || ''),
      LOOK_UP_BTN: null,
      AMMOUNT: this.Repoint.AMMOUNT || '',
      MAIN_ACCT_Y_N: 'Y',
      REPOINT_ACCT_KEY: 0,
      DISABLED: false,
      DELETE_BTN: true,
      GROUP_KEY: this.group_key,
      TRANS_HEADER_KEY: tempTransHeader_key,
      loadLookupSchedule: this.filterDataByKey('FORM', 'SCHEDULE', lookupData, firstMapRow ? firstMapRow.FORM : '', ''),
      loadLookupLineDesc: this.filterDataByKey('SCHEDULE', 'LINE_DESC', lookupData, firstMapRow ? firstMapRow.SCHEDULE : '', firstMapRow ? firstMapRow.FORM : ''),
      loadLookupColumn: this.filterDataByKey('LINE_DESC', 'COL', lookupData, firstMapRow ? lineDesc : '', firstMapRow ? firstMapRow.SCHEDULE : '')
    });
    this.cdr.detectChanges();
  }

  toggleLookup() {
    this.lookUpMapping = !this.lookUpMapping;
    this.cdr.detectChanges();
  }

  applycyamt(index: number) {
    if (!this.repointList[index]) {
      return;
    }
    this.repointList[index].AMMOUNT = this.remainingCyAmount;
    this.repointAmt();
  }

  changeSystemacct() {
    let hasError = false;
    this.repointList.forEach((item: any, idx: number) => {
      item.sysacctflag = !item.SYSC_ACCT;
      item.sameacctFlag = false;
      if (item.sysacctflag) {
        hasError = true;
      }
      if (!item.sysacctflag) {
        for (let j = 0; j < this.repointList.length; j++) {
          if (idx !== j && this.repointList[j].SYSC_ACCT === item.SYSC_ACCT) {
            item.sameacctFlag = true;
            hasError = true;
            break;
          }
        }
        // Map selected SYS_DROPDOWN string back to SYS_ACCT_KEY (legacy: trialBalanceController.js:1564).
        if (this.sys_acc_dropdown_data && this.sys_acc_dropdown_data.length) {
          const match = this.sys_acc_dropdown_data.find((sys: any) => sys.SYS_DROPDOWN === item.SYSC_ACCT);
          if (match) {
            item.SYS_ACCT_KEY = match.SYS_ACCT_KEY;
          }
        }
      }
    });
    this.sysacctFlag = hasError;
    this.cdr.detectChanges();
  }

  getSystemAccountOptions(): string[] {
    const options = (this.sys_acc_dropdown_data || [])
      .map((item: any) => item.SYS_DROPDOWN)
      .filter((value: any) => !!value);
    return _.uniq(options);
  }

  removeRepointAmount(index: number, group_key: number) {
    if (this.sendobj.length > index) {
      this.sendobj[index].TYPE = 'D';
      this.tempDeletedRepointList.push(this.sendobj[index]);
      this.sendobj.splice(index, 1);
    }
    this.repointList.splice(index, 1);
    let i = 0;
    while (i < this.sendobj.length) {
      if (this.sendobj[i].GROUP_KEY === group_key) {
        this.sendobj[i].TYPE = 'D';
        this.sendobj.splice(i, 1);
      } else {
        i++;
      }
    }
    let j = 0;
    while (j < this.repointList.length) {
      if (this.repointList[j].GROUP_KEY === group_key) {
        this.repointList[j].TYPE = 'D';
        this.repointList.splice(j, 1);
      } else {
        j++;
      }
    }
    this.repointAmt();
    this.adjDescChanged();
    this.cdr.detectChanges();
  }

  repointAmt() {
    this.repointingAmount = 0;
    this.acctzeroflag = false;
    let temp_group_key: number | null = null;
    this.repointList.forEach((repoint: any) => {
      if (repoint.AMMOUNT != null && repoint.AMMOUNT !== '' && repoint.GROUP_KEY !== temp_group_key) {
        this.repointingAmount = this.repointingAmount + parseInt(String(repoint.AMMOUNT), 10);
        temp_group_key = repoint.GROUP_KEY;
      }
    });
    this.remainingCyAmount = this.cyAmount - this.repointingAmount;
    this.showRepointingError = this.repointingAmount > this.cyAmount;
    this.adjAmount5471 = this.cyAmount * (this.rowData.HO_FX_RATE || 0) + (this.rowData.HO_ELIM_AMT || 0) - this.repointingAmount * (this.rowData.HO_FX_RATE || 0);
    this.adjAmount8858 = this.rowData.CURR_8858 === undefined ? 0 : (this.cyAmount - this.repointingAmount) * (this.rowData.FX_RATE_8858 || 0);
    for (const repoint of this.repointList) {
      repoint.acctzeroflag = false;
      if (repoint.AMMOUNT === 0 || repoint.AMMOUNT === undefined || repoint.AMMOUNT === 'NaN' || repoint.AMMOUNT === '') {
        repoint.acctzeroflag = true;
        this.acctzeroflag = true;
      }
    }
    this.cdr.detectChanges();
  }

  updateAmt(group_key: number, amt: number | string) {
    this.repointList.filter((obj: any) => obj.GROUP_KEY === group_key).forEach((obj: any) => {
      obj.AMMOUNT = amt;
    });
    this.repointAmt();
  }

  changeLine(repointObj: any) {
    if (repointObj.IRS_LINE_DESC) {
      repointObj.IRS_LINE = repointObj.IRS_LINE_DESC.split('-')[0].replace(/^\s+|\s+$/g, '');
    }
    this.cdr.detectChanges();
  }

  getLookupNext(key: number, nextLookupKey: string, repointObj: any) {
    const lookupData = _.cloneDeep(this.sys_acc_lookup_data);
    switch (key) {
      case 1:
        repointObj.loadLookupSchedule = this.filterDataByKey('FORM', nextLookupKey, lookupData, repointObj.IRS_Form, '');
        break;
      case 2:
        repointObj.loadLookupLineDesc = this.filterDataByKey('SCHEDULE', nextLookupKey, lookupData, repointObj.IRS_SCHEDULE, repointObj.IRS_Form);
        break;
      case 3:
        repointObj.loadLookupColumn = this.filterDataByKey('LINE_DESC', nextLookupKey, lookupData, repointObj.IRS_LINE_DESC, repointObj.IRS_SCHEDULE);
        break;
    }
    this.cdr.detectChanges();
  }

  private filterDataByKey(currentLookupKey: string, nextLookupKey: string, lookupData: any[], currentLookupValue: string, preLookUpValue: string): string[] {
    let nextLookupData: string[] = [];
    const currentLookupFilter = lookupData.filter((object: any) => {
      if (nextLookupKey === 'SCHEDULE') {
        const uniqueSched: string[] = [];
        for (let k = 0; k < this.loadSystemAndLocalAccountData.length; k++) {
          if (this.loadSystemAndLocalAccountData[k].FORM === currentLookupValue) {
            uniqueSched.push(this.loadSystemAndLocalAccountData[k].SCHEDULE);
          }
        }
        return object[currentLookupKey] === currentLookupValue && _.indexOf(uniqueSched, object['SCHEDULE']) !== -1;
      } else if (nextLookupKey === 'LINE_DESC') {
        return object[currentLookupKey] === currentLookupValue && object['FORM'] === preLookUpValue;
      } else if (nextLookupKey === 'COL') {
        return object[currentLookupKey] === currentLookupValue && object['SCHEDULE'] === preLookUpValue;
      }
      return object[currentLookupKey] === currentLookupValue;
    });
    currentLookupFilter.forEach((object: any) => {
      nextLookupData.push(object[nextLookupKey]);
    });
    nextLookupData = _.uniq(nextLookupData);
    if (nextLookupKey === 'LINE_DESC') {
      nextLookupData = _.sortBy(nextLookupData, (line: string) => {
        const match = line.split('-')[0].match(/(\d+)/);
        return match ? parseInt(match[0], 10) : 0;
      });
    }
    return nextLookupData;
  }

  private addToJson(repointObj: any, isDefaultRecord: boolean) {
    // Match legacy AngularJS (trialBalanceController.js:1444-1473) field-for-field.
    // Backend (PKG_GT_TRIAL_BALANCE / V_COA_GOK) keys lookups by LOCAL_ACCT_KEY +
    // SYSTEM_ACCT_KEY + TAX_YEAR + SCENARIO + JCD_KEY, not by FORM/SCHEDULE/LINE/COL.
    const globalParams = this.globalService?.globalParams || this.globalService || {};
    const taxYear = this.rowData.TAX_YEAR || this.filterParams?.tax_year || globalParams?.tax_year;
    const scenario = this.filterParams?.scenario || globalParams?.scenario || this.rowData?.SCENARIO;
    const jcdKey = this.rowData.JCD_KEY || this.filterParams?.jcd_key || globalParams?.jcd_key;

    const returnObjD: any = {};
    returnObjD['TYPE'] = isDefaultRecord ? 'E' : 'I';
    returnObjD['COMBINATION_KEY'] = this.rowData.COMBINATION_KEY;
    returnObjD['TAX_YEAR'] = taxYear;
    returnObjD['SCENARIO'] = scenario;
    returnObjD['JCD_KEY'] = jcdKey;
    returnObjD['LOCAL_CHART_KEY'] = this.rowData.LOCAL_CHART_KEY;
    returnObjD['LOCAL_ACCT_KEY'] = this.rowData.LOCAL_ACCT_KEY;
    returnObjD['SYSTEM_ACCT_KEY'] = this.rowData.SYSTEM_ACCT_KEY;
    returnObjD['OLD_SYSTEM_ACCT'] = repointObj.SYS_ACCT_KEY;
    returnObjD['NEW_SYSTEM_ACCT'] = repointObj.SYS_ACCT_KEY;
    returnObjD['OLD_ADJ_AMT'] = repointObj.AMMOUNT;
    returnObjD['NEW_ADJ_AMT'] = repointObj.AMMOUNT;
    returnObjD['TRANS_HEADER_KEY'] = repointObj.TRANS_HEADER_KEY !== '' ? repointObj.TRANS_HEADER_KEY : '';
    returnObjD['TRANS_DETAILS_KEY'] = repointObj.TRANS_DETAILS_KEY !== '' ? repointObj.TRANS_DETAILS_KEY : '';
    returnObjD['OLD_ADJUSTMENT_DESC'] = this.OLD_DESC;
    returnObjD['NEW_ADJUSTMENT_DESC'] = this.Repoint.ADJUSTMENT_DESC;
    returnObjD['SOURCE_SYSTEM'] = this.rowData.SOURCE_SYSTEM;
    returnObjD['TP_KEY'] = repointObj?.tpObject?.TP_KEY ?? repointObj.TP_KEY ?? '';
    returnObjD['TP_ENTITY'] = repointObj.TP_ENTITY ?? '';
    returnObjD['REPOINT_ACCT_KEY'] = repointObj.REPOINT_ACCT_KEY;
    returnObjD['MAIN_ACCT_Y_N'] = repointObj.MAIN_ACCT_Y_N;
    returnObjD['GROUP_KEY'] = repointObj.GROUP_KEY;
    this.sendobj.push(returnObjD);
  }

  save() {
    if (this.crudLoading) {
      this.gtwSnackbarService.openSnackBar('Please wait while we save this request', 'gtw-snackbar--yellow');
      return;
    }
    if (!this.repointList || this.repointList.length === 0) {
      this.gtwSnackbarService.openSnackBar('Please add at least one repoint before saving', 'gtw-snackbar--red');
      return;
    }
    if (!this.Repoint.ADJUSTMENT_DESC || String(this.Repoint.ADJUSTMENT_DESC).trim() === '') {
      this.showRepointingDescError = true;
      this.gtwSnackbarService.openSnackBar('Please add repointing description', 'gtw-snackbar--red');
      this.cdr.detectChanges();
      return;
    }
    this.crudLoading = true;
    this.acctzeroflag = false;
    this.adjDescChanged();
    for (const repoint of this.repointList) {
      repoint.acctzeroflag = false;
      if (repoint.AMMOUNT === 0 || repoint.AMMOUNT === undefined || !repoint.AMMOUNT || repoint.AMMOUNT === null || repoint.AMMOUNT === 'NaN') {
        repoint.acctzeroflag = true;
        this.acctzeroflag = true;
      }
    }
    if (!this.showRepointingError && !this.showRepointingDescError && !this.acctzeroflag) {
      // Match legacy AngularJS (trialBalanceController.js:1589-1620): for an existing
      // record (TYPE='E') the only mutable fields are NEW_SYSTEM_ACCT, NEW_ADJ_AMT,
      // NEW_ADJUSTMENT_DESC and TP_KEY. If none of those changed, drop the record.
      const finalRepointList = JSON.parse(JSON.stringify(this.repointList));
      for (let i = 0; i < finalRepointList.length; i++) {
        if (this.sendobj.length > i) {
          this.sendobj[i].NEW_ADJUSTMENT_DESC = this.Repoint.ADJUSTMENT_DESC;
          if (this.sendobj[i].TYPE === 'E') {
            this.sendobj[i].NEW_SYSTEM_ACCT = finalRepointList[i].SYS_ACCT_KEY;
            this.sendobj[i].NEW_ADJ_AMT = finalRepointList[i].AMMOUNT;
            this.sendobj[i].TP_KEY = finalRepointList[i].tpObject?.TP_KEY ?? finalRepointList[i].TP_KEY ?? '';
            this.sendobj[i].REPOINT_ACCT_KEY = finalRepointList[i].REPOINT_ACCT_KEY;
            this.sendobj[i].GROUP_KEY = finalRepointList[i].GROUP_KEY;

            if (this.sendobj[i].OLD_SYSTEM_ACCT === this.sendobj[i].NEW_SYSTEM_ACCT
                && this.sendobj[i].OLD_ADJ_AMT === this.sendobj[i].NEW_ADJ_AMT
                && this.sendobj[i].OLD_ADJUSTMENT_DESC === this.sendobj[i].NEW_ADJUSTMENT_DESC) {
              this.sendobj.splice(i, 1);
              finalRepointList.splice(i, 1);
              i--;
            }
          }
        } else {
          this.addToJson(finalRepointList[i], false);
        }
      }
      const finalSendObj = this.sendobj.concat(this.tempDeletedRepointList);
      if (finalSendObj.length === 0) {
        this.gtwSnackbarService.openSnackBar('No changes to save', 'gtw-snackbar--yellow');
        this.crudLoading = false;
        this.cdr.detectChanges();
        return;
      }
      const jsonSetting = {
        TAX_YEAR: this.rowData.TAX_YEAR,
        tax_year: this.rowData.TAX_YEAR,
        SCENARIO: this.filterParams?.scenario || this.globalService?.scenario,
        JCD_KEY: this.rowData.JCD_KEY || this.filterParams?.jcd_key || this.globalService?.jcd_key
      };
      this.saveTrialBalanceData(jsonSetting, finalSendObj, 'Repoint has been saved successfully');
    } else {
      if (this.showRepointingDescError) {
        this.gtwSnackbarService.openSnackBar('Please add repointing description', 'gtw-snackbar--red');
      } else if (this.acctzeroflag) {
        this.gtwSnackbarService.openSnackBar('Amount cannot be zero', 'gtw-snackbar--red');
      }
      this.crudLoading = false;
      this.cdr.detectChanges();
    }
  }

  private saveTrialBalanceData(jsonSetting: any, sendobj: any[], message: string) {
    this.service.saveTb(
      this.baseURLs.api,
      jsonSetting,
      sendobj,
      this.rowData.SOURCE_SYSTEM,
      this.globalService?.globalParams || {},
      this.filterParams
    ).pipe(takeUntil(this.unsubscribe$)).subscribe(
      (result: any) => {
        this.crudLoading = false;
        if (result.errorMessage && result.errorMessage !== 'null') {
          this.gtwSnackbarService.openSnackBar(result.errorMessage, 'gtw-snackbar--red');
        } else {
          this.gtwSnackbarService.openSnackBar(message, 'gtw-snackbar--green');
          this.is_data_saved = true;
          this.requestGridUpdate.emit('refresh');
        }
        this.cdr.detectChanges();
      },
      () => {
        this.crudLoading = false;
        this.gtwSnackbarService.openSnackBar('An error occurred while saving. Please try again.', 'gtw-snackbar--red');
        this.cdr.detectChanges();
      }
    );
  }

  reset() {
    this.crudLoading = false;
    this.repointList = [];
    this.sys_acc_lookup_data = [];
    this.sys_acc_dropdown_data = [];
    this.tpSearchResults = [];
    this.activeTPSearchIndex = -1;
    this.repoint_data = [];
    this.Repoint.ADJUSTMENT_DESC = '';
    this.getSystemAcctLookup();
    this.getSystmAcctDropDown();
    this.fetchSystemAcctData();
    this.getDefaultSystemAcctValues();
    this.repointAmt();
  }

  cancel() {
    this.sendobj = [];
    this.requestGridUpdate.emit('cancel');
  }

  private fetchSystemAcctData() {
    const globalParams = this.globalService?.globalParams || this.globalService || {};
    this.service.fetchSystemAcctData(
      this.baseURLs.api,
      this.rowData.TAX_YEAR,
      this.rowData.LOCAL_ACCT_KEY,
      this.rowData.SYSTEM_ACCT_KEY,
      this.rowData.SOURCE_SYSTEM,
      globalParams
    ).pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {
      this.loadSystemAndLocalAccountData = data?.jsonObject || [];
      this.cdr.detectChanges();
    });
  }

  private getDefaultSystemAcctValues() {
    const globalParams = this.globalService?.globalParams || this.globalService || {};
    this.service.getDefaultSystemAcctValues(
      this.baseURLs.api,
      this.filterParams?.scenario || globalParams?.scenario || this.rowData?.SCENARIO,
      this.rowData.JCD_KEY || this.filterParams?.jcd_key || globalParams?.jcd_key,
      this.filterParams?.tax_year || globalParams?.tax_year || this.rowData?.TAX_YEAR,
      this.rowData.SOURCE_SYSTEM,
      this.rowData.COMBINATION_KEY,
      this.rowData.LOCAL_ACCT,
      this.rowData.LOCAL_CHART_KEY,
      this.rowData.SCREEN_KEY || this.filterParams?.screen_key || globalParams?.screen_key || 175,
      globalParams,
      this.filterParams || {}
    ).pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {
      this.repoint_data = data?.jsonObject || [];
      this.processRepointData();
      this.loadLookUpData = true;
      this.isLoading = false;
      this.cdr.detectChanges();
    });
  }

  private getSystemAcctLookup() {
    const globalParams = this.globalService?.globalParams || this.globalService || {};
    this.service.getSystemAcctLookup(
      this.baseURLs.api,
      this.rowData.SCREEN_KEY,
      this.rowData.SYSTEM_ACCT_TYPE,
      this.rowData.SOURCE_SYSTEM,
      globalParams,
      this.filterParams || {},
      this.rowData || {}
    ).pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {
      this.sys_acc_lookup_data = data?.jsonObject || [];
      this.updateRepointListLookupData();
      this.loadLookUpData = true;
      this.cdr.detectChanges();
    });
  }

  private processRepointData() {
    if (this.repoint_data.length > 0) {
      this.repointList = [];
      let temp_group_key: number | null = null;

      this.repoint_data.forEach((sys_acc_data: any) => {
        this.Repoint.SYSC_ACCT = sys_acc_data.SYS_ACCT;
        this.Repoint.AMMOUNT = Number(sys_acc_data.AMOUNT);
        this.Repoint.ADJUSTMENT_DESC = sys_acc_data.ADJUSTMENT_DESC;
        this.Repoint.SYS_ACCT_KEY = sys_acc_data.SYS_ACCT_KEY;
        this.Repoint.TRANS_HEADER_KEY = sys_acc_data.TRANS_HEADER_KEY;
        this.Repoint.TRANS_DETAILS_KEY = sys_acc_data.TRANS_DETAILS_KEY;
        this.Repoint.IRS_Form = sys_acc_data.FORM;
        this.Repoint.IRS_SCHEDULE = sys_acc_data.SCHEDULE;
        this.Repoint.IRS_LINE = sys_acc_data.LINE || '';
        this.Repoint.CHECK_COL = sys_acc_data.COL;
        this.Repoint.IRS_LINE_DESC = sys_acc_data.LINE_DESC || '';
        this.OLD_DESC = this.Repoint.ADJUSTMENT_DESC;
        this.Repoint.REPOINT_ACCT_KEY = sys_acc_data.REPOINT_ACCT_KEY;
        this.Repoint.MAIN_ACCT_Y_N = sys_acc_data.MAIN_ACCT_Y_N;
        this.Repoint.DISABLED = false;
        this.Repoint.DELETE_BTN = temp_group_key !== sys_acc_data.GROUP_KEY;
        this.Repoint.GROUP_KEY = sys_acc_data.GROUP_KEY;
        // Persisted Trading Partner — legacy: trialBalanceController.js:1782, 1796.
        this.Repoint.TP_ENTITY = sys_acc_data.TP_ENTITY;
        this.Repoint.TP_KEY = sys_acc_data.TP_KEY;
        this.Repoint.TP_REP_PD = sys_acc_data.TP_REP_PD;
        this.group_key = sys_acc_data.GROUP_KEY;
        temp_group_key = sys_acc_data.GROUP_KEY;

        this.repointList.push({
          SYSC_ACCT: this.Repoint.SYSC_ACCT,
          SYS_ACCT_KEY: this.Repoint.SYS_ACCT_KEY,
          TRANS_HEADER_KEY: this.Repoint.TRANS_HEADER_KEY,
          TRANS_DETAILS_KEY: this.Repoint.TRANS_DETAILS_KEY,
          IRS_Form: this.Repoint.IRS_Form,
          IRS_SCHEDULE: this.Repoint.IRS_SCHEDULE,
          IRS_LINE: this.Repoint.IRS_LINE,
          CHECK_COL: this.Repoint.CHECK_COL,
          IRS_LINE_DESC: this.Repoint.IRS_LINE_DESC,
          LOOK_UP_BTN: null,
          AMMOUNT: this.Repoint.AMMOUNT,
          REPOINT_ACCT_KEY: this.Repoint.REPOINT_ACCT_KEY,
          MAIN_ACCT_Y_N: this.Repoint.MAIN_ACCT_Y_N,
          DISABLED: this.Repoint.DISABLED,
          DELETE_BTN: this.Repoint.DELETE_BTN,
          GROUP_KEY: this.Repoint.GROUP_KEY,
          TP_ENTITY: this.Repoint.TP_ENTITY,
          TP_KEY: this.Repoint.TP_KEY,
          TP_REP_PD: this.Repoint.TP_REP_PD,
          tpSearchText: this.Repoint.TP_ENTITY,
          tpObject: this.Repoint.TP_KEY ? {
            TP_ENTITY: this.Repoint.TP_ENTITY,
            TP_KEY: this.Repoint.TP_KEY,
            TP_REP_PD: this.Repoint.TP_REP_PD
          } : undefined
        });

        this.addToJson(this.Repoint, true);
      });

      this.repointAmt();
      this.changeSystemacct();
      this.updateRepointListLookupData();
    }
  }

  private updateRepointListLookupData() {
    if (!(this.sys_acc_lookup_data && this.sys_acc_lookup_data.length > 0)) {
      return;
    }
    if (this.repointList.length > 0) {
      const lookupData = _.cloneDeep(this.sys_acc_lookup_data);
      for (const repoint of this.repointList) {
        repoint.loadLookupSchedule = this.filterDataByKey('FORM', 'SCHEDULE', lookupData, repoint.IRS_Form, '');
        repoint.loadLookupLineDesc = this.filterDataByKey('SCHEDULE', 'LINE_DESC', lookupData, repoint.IRS_SCHEDULE, repoint.IRS_Form);
        repoint.loadLookupColumn = this.filterDataByKey('LINE_DESC', 'COL', lookupData, repoint.IRS_LINE_DESC, repoint.IRS_SCHEDULE);
      }
    }
  }

  trackByIndex(index: number): number {
    return index;
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }
}

